import { CMSChildrenContainer } from '@/cmsComponents/ChildrenContainer';
import dynamic from 'next/dynamic';
import React from 'react';
import { IJobDetail } from 'types/jobs';

import Grid from '@material-ui/core/Grid';

import styles from './JobSnippet.module.scss';

const JobSnippetItem = dynamic(() => import('@/cmsComponents/JobSnippet/Item/JobSnippetItem'));

export enum JobSnippetStyle {
  FullWidth = 'Full_Width',
  TwoOfThreeWidth = 'One_Column',
  TwoColumns = 'Two_Column',
  ThreeColumns = 'Three_Column',
}

const styleToGridColumn = (style: JobSnippetStyle) => {
  switch (style) {
    case JobSnippetStyle.ThreeColumns:
      return 4;
    case JobSnippetStyle.TwoColumns:
      return 6;
    default:
      return 12;
  }
};

interface IProps {
  id?: number;
  heading?: string;
  layout?: JobSnippetStyle;
  jobs: Array<IJobDetail>;
}

export const JobSnippet: React.FC<IProps> = ({
  heading,
  jobs,
  layout = JobSnippetStyle.FullWidth,
}) => {
  return (
    <CMSChildrenContainer>
      <div className={styles.container}>
        {jobs && (
          <div className={styles[layout]}>
            {heading && (
              <div className={styles.title}>
                <h5>{heading}</h5>
              </div>
            )}
            <Grid container spacing={1}>
              {jobs.map(i => (
                <Grid key={i.id} item xs={12} md={styleToGridColumn(layout)}>
                  <JobSnippetItem data={i} style={layout} />
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </div>
    </CMSChildrenContainer>
  );
};
